class Group {
  // ---------------------------------------------------------------------------------------------------------
  // --	Group
  // ---------------------------------------------------------------------------------------------------------

  constructor(dom) {
    //dom参照
    this.$dom = dom;

    //フラグ
    this.isOpen = true;

    //最初は閉じる
    // this.close(0);

    //ボタンで開閉
    this.$dom.find(".pg-result__answers-title >a").click((e) => {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
      return false;
    });
  }

  open(duration = 500) {
    this.isOpen = true;
    this.$dom.find(".pg-result__answers-list").slideDown(duration);
    this.$dom.find(".pg-result__answers-title").removeClass("is-close");
  }

  close(duration = 500) {
    this.isOpen = false;
    this.$dom.find(".pg-result__answers-list").slideUp(duration);
    this.$dom.find(".pg-result__answers-title").addClass("is-close");
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default Group;
